var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iconName)?_c('svg',{class:_vm.svgClass,attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"href":_vm.iconName}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }